<script lang="ts">
	import "@glidejs/glide/dist/css/glide.core.min.css";
	import type { ProductForCustomer } from "../../../../core/schema/Product.js";
	import type { UploadedFile } from "../../../../core/schema/UploadedFile.js";
	import { getGlobalSettings } from "../../getGlobalSettings.js";
	import DynamicPicture from "../Picture/DynamicPicture.svelte";
	import Glide from "@glidejs/glide";
	import { disableGlidePerSlideAmount } from "../../utils/disableGlidePerSlideAmount.js";
	import StaticPicture from "../Picture/StaticPicture.svelte";
	import { appName } from "../../../../core/schema/appName.js";
	import logo from "../../../../core/assets/logo.svg";
	import type { ActionReturn } from "svelte/action";

	export let images: UploadedFile[];
	export let product: ProductForCustomer;
	export let gliderClass = "";
	export { gliderClass as class };

	const { TENANT_LOCALE } = getGlobalSettings();

	function glide(element: HTMLDivElement): ActionReturn {
		const glideOptions = {
			type: "carousel",
			startAt: 0,
			focusAt: "center",
			perView: 2.75,
			autoplay: 7000,
			hoverpause: false,
			animationDuration: 650,
			animationTimingFunc: "ease-in-out",
			gap: 9,
			keyboard: true,
			cloningRatio: 2,
			breakpoints: {
				736: { perView: 2.7 },
				720: { perView: 2.6 },
				670: { perView: 2.35 },
				590: { perView: 2.2 },
				570: { perView: 2.1 },
				540: { perView: 2 },
				515: { perView: 1.85 },
				480: { perView: 1.75 },
				455: { perView: 1.65 },
				420: { perView: 1.5 },
				370: { perView: 1.35 },
				340: { perView: 1.225 },
			},
		} satisfies Partial<Glide.Options>;

		const glide = new Glide(element, { ...glideOptions }).mount();
		glide.on("resize", () => {
			disableGlidePerSlideAmount(glide, element);
		});

		return {
			destroy(): void {
				glide.destroy();
			},
		};
	}
</script>

{#if images.length > 0}
	<div class={gliderClass}>
		<div use:glide class="glide">
			<div class="glide__track" data-glide-el="track">
				<div class="glide__slides">
					{#each images as image, i}
						<DynamicPicture
							class="glide__slide !h-[16rem]"
							imgClass="max-w-full h-full w-auto rounded-lg aspect-square object-cover"
							{image}
							width={256}
							height={256}
							bucket="storage"
							loading="eager"
							alt="Fotografie – {product.name[TENANT_LOCALE]} ({i + 1}/{images.length})"
						/>
					{/each}
				</div>
				<div class="flex justify-center">
					<div class="glide__bullets bg-secondaryBlack-150 mt-5 flex h-[2px] w-10/12" data-glide-el="controls[nav]">
						{#each images as _image, i}
							<span
								class="glide__bullet text-secondaryBlack hover:bg-secondaryBlack-300 w-full cursor-pointer transition-all duration-200"
								data-glide-dir="={i}"
							></span>
						{/each}
					</div>
				</div>
			</div>
		</div>
	</div>
{:else}
	<div class="flex justify-center">
		<div class="bg-secondaryBlack-40 group flex h-[17rem] w-[90%] items-center justify-center md:hidden">
			<StaticPicture
				alt="Logo {appName}"
				image={logo}
				class="w-24 opacity-50 transition-all duration-300 group-hover:opacity-100"
				loading="eager"
				width={96}
				height={96}
			/>
		</div>
	</div>
{/if}
